import React, { useState, useRef, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";

// contexts
import AuthContext from "../../contexts/authContext";

// API
import { postData, apiURL, getData } from "../../services/API";

// components
import Verification from "./Verification";
import Stepper from "../../components/shared/Stepper";
import Loading from "../../components/shared/Loading";
import NoticeMsg from "../../components/shared/NoticeMsg";
import ProfileInfo from "./CompleteRegister";
import Password from "./Password";

// forms & api
import Input from "../../components/shared/Form/Input";
import config from "./config.json";
import MobileNavbar from "../../components/Header/Mobile/MobileNavbar";
import { Link, useLocation, useParams } from "react-router-dom";
import CircleLoading from "../../components/shared/CircleLoading";
import { setItemStorage } from "../../Localstorage/useLocalStorage";
import { RefContextData } from "../../contexts/RefContext";
import { Dropdown } from "primereact/dropdown";

const Auth = () => {
  const {
    api_url: { p_get_login_sms_code, p_change_pass_code },
  } = config;

  const { register, getValues } = useForm();

  // context
  const authContext = useContext(AuthContext);
  const { refCode, setRefCode } = useContext(RefContextData);
  // 31743562987
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isRegistered, setIsRegistered] = useState(null);
  const [serverRes, setServerRes] = useState({});
  const [loading, setLoading] = useState(false);
  const [validate, setValidate] = useState(false);
  const [err, setErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [stepper, setStepper] = useState(1);
  const [resetPassword, setResetPassword] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [isComplite, setIsComplite] = useState(false);
  const [companyInfo, setCompanyInfo] = useState({});
  const [companyLoading, setCompanyLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [codeOpen, setCodeOpen] = useState(false);

  const code = [
    {
      id: 1,
      name: "۹۸+",
      code: "+98",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 36 36"
        >
          <path
            fill="#da0001"
            d="M0 27a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-4H0z"
          ></path>
          <path fill="#eee" d="M0 13h36v10H0z"></path>
          <path
            fill="#239f40"
            d="M36 13V9a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v4z"
          ></path>
          <path fill="#e96667" d="M0 23h36v1H0z"></path>
          <g fill="#be1931">
            <path d="M19.465 14.969c.957.49 3.038 2.953.798 5.731c1.391-.308 3.162-4.408-.798-5.731m-2.937 0c-3.959 1.323-2.189 5.423-.798 5.731c-2.24-2.778-.159-5.241.798-5.731m1.453-.143c.04.197 1.101.436.974-.573c-.168.408-.654.396-.968.207c-.432.241-.835.182-.988-.227c-.148.754.587.975.982.593"></path>
            <path d="M20.538 17.904c-.015-1.248-.677-2.352-1.329-2.799c.43.527 1.752 3.436-.785 5.351l.047-5.097l-.475-.418l-.475.398l.08 5.146l-.018-.015c-2.563-1.914-1.233-4.837-.802-5.365c-.652.447-1.315 1.551-1.329 2.799c-.013 1.071.477 2.243 1.834 3.205a6.4 6.4 0 0 1-1.678.201c.464.253 1.34.192 2.007.131l.001.068l.398.437l.4-.455v-.052c.672.062 1.567.129 2.039-.128a6.3 6.3 0 0 1-1.732-.213c1.344-.961 1.83-2.127 1.817-3.194"></path>
          </g>
          <path fill="#7bc58c" d="M0 12h36v1H0z"></path>
        </svg>
      ),
    },
    {
      id: 2,
      name: "۹۰+",
      code: "+90",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 64 64"
        >
          <path
            fill="#ec1c24"
            d="M64 43c0 6.075-3.373 11-10 11H10C3.373 54 0 49.075 0 43V21c0-6.075 3.373-11 10-11h44c6.627 0 10 4.925 10 11z"
          />
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M39.778 38.32c-2.302 3.591-7.095 5.856-12.11 4.391c-4.733-1.386-7.984-5.972-7.715-10.918c.262-4.968 3.994-9.193 8.844-10.05c5.139-.913 9.267 1.842 11.03 4.726c-2.089-2.054-4.518-2.979-7.362-2.654c-2.228.256-4.09 1.263-5.548 2.963c-2.854 3.322-2.749 8.304.231 11.439c1.709 1.798 3.811 2.739 6.292 2.762c2.479.018 4.582-.92 6.344-2.654"
          />
          <path
            fill="#fff"
            d="m44.23 28.396l2.03 1.884l2.708-.6l-1.167 2.52l1.409 2.381l-2.75-.331l-1.839 2.08l-.531-2.722l-2.548-1.104l2.422-1.344z"
          />
        </svg>
      ),
    },
    {
      id: 3,
      name: "۹۳+",
      code: "+93",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 36 36"
        >
          <path
            fill="#141414"
            d="M36 26.999a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-18a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4z"
          ></path>
          <path
            fill="#007a36"
            d="M32 4.999a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4h-8v-26z"
          ></path>
          <path fill="#d32011" d="M12 4.999h12v26H12z"></path>
          <path
            fill="#fff"
            d="M22.048 23.783c-.032.08-.141.151-.227.117s-.116-.161-.084-.241s.277-.319.303-.309s.04.353.008.433m.061.075c-.085.014-.179.104-.164.196c.015.091.131.149.217.135s.372-.201.368-.228s-.336-.116-.421-.103m.352-.401c-.03.074-.131.14-.21.109s-.108-.149-.078-.224s.257-.296.281-.287s.036.328.007.402m.056.07c-.079.013-.166.097-.152.182s.122.138.201.125s.345-.186.341-.212s-.311-.107-.39-.095m-1.831.538c-.019.102-.13.212-.24.192s-.175-.162-.157-.264c.019-.102.251-.442.284-.436s.131.406.113.508m.089.074c-.097.036-.186.166-.147.27s.19.144.288.108s.391-.325.379-.357s-.423-.057-.52-.021m.265-.483c-.015.085-.108.176-.199.16s-.146-.135-.13-.22s.209-.368.236-.363s.109.338.093.423m.074.062c-.081.03-.154.138-.122.224s.158.12.239.09s.325-.271.315-.297c-.009-.025-.351-.047-.432-.017m.266-.462c-.014.079-.1.163-.185.148s-.135-.125-.121-.204s.194-.341.219-.337s.101.314.087.393m.069.057c-.075.028-.143.128-.113.208s.147.111.222.083s.301-.251.293-.275s-.327-.044-.402-.016m.225-.402c-.013.071-.091.148-.167.134s-.122-.113-.109-.184s.175-.309.198-.304c.022.003.091.283.078.354m.062.052c-.068.025-.13.115-.102.188c.027.073.133.1.201.075s.273-.227.265-.249s-.296-.039-.364-.014m-.097 1.755c-.076.07-.231.091-.307.009s-.043-.235.033-.305s.467-.202.489-.178s-.139.404-.215.474m.026.113c-.1-.029-.248.021-.279.127c-.032.107.066.229.165.259c.1.029.508-.025.517-.057c.01-.031-.303-.299-.403-.329m.503-.226c-.063.059-.192.076-.255.008s-.036-.195.028-.254c.063-.059.388-.168.407-.148s-.117.335-.18.394m.022.094c-.083-.025-.206.017-.232.106s.054.191.137.215c.083.025.422-.021.43-.047c.008-.027-.253-.25-.335-.274m.49-.21c-.059.054-.178.07-.237.007s-.033-.181.026-.235s.36-.156.377-.137s-.107.31-.166.365m.021.087c-.077-.023-.191.016-.216.098s.051.177.127.2s.392-.019.399-.044s-.234-.231-.31-.254m.421-.186c-.053.049-.161.064-.214.007s-.03-.164.023-.213s.326-.141.341-.124s-.097.281-.15.33m.019.079c-.069-.021-.173.014-.195.089c-.022.074.046.16.115.181s.354-.017.361-.04c.006-.022-.212-.209-.281-.23m.343-2.771c.013.103-.061.241-.172.254s-.215-.103-.228-.206s.109-.497.142-.501s.245.35.258.453m.107.044c-.082.063-.128.213-.06.301s.224.081.307.018s.277-.427.257-.453c-.022-.026-.422.071-.504.134m.11-.54c.01.086-.051.2-.143.212s-.179-.085-.19-.171c-.01-.086.091-.413.118-.417c.028-.003.205.29.215.376m.089.037c-.068.053-.107.177-.05.25s.187.067.255.015s.23-.355.213-.377c-.016-.021-.349.06-.418.112m.117-.52c.01.079-.047.186-.133.196s-.166-.079-.176-.159c-.01-.079.084-.383.109-.386c.026-.003.19.269.2.349m.083.034c-.063.049-.099.164-.046.232s.173.063.236.014s.214-.329.198-.349s-.325.054-.388.103m.095-.45c.009.072-.043.168-.12.178s-.15-.072-.159-.144s.076-.347.099-.349c.023-.004.172.243.18.315m.075.031c-.057.044-.089.149-.042.21s.157.057.214.012c.057-.044.193-.298.179-.316s-.293.049-.351.094m.428 1.705c-.052.09-.194.156-.29.1s-.11-.212-.059-.301c.052-.09.386-.332.414-.315s-.013.426-.065.516m.058.1c-.104.001-.231.093-.229.204s.131.2.234.198c.104-.001.478-.174.477-.208c.001-.032-.378-.195-.482-.194m.413-.365c-.043.075-.161.129-.241.083s-.092-.176-.049-.251s.321-.276.345-.262s-.011.355-.055.43m.049.083c-.086.001-.192.078-.191.17s.109.166.195.165s.397-.145.397-.173s-.315-.163-.401-.162m.406-.346c-.04.069-.15.12-.224.077s-.085-.163-.045-.232s.297-.256.32-.243s-.011.329-.051.398m.046.077c-.08.001-.178.072-.177.158s.101.154.181.153s.368-.135.368-.16s-.292-.152-.372-.151m.347-.302c-.036.063-.135.109-.203.07c-.067-.039-.077-.148-.041-.21s.269-.231.289-.22c.021.011-.009.297-.045.36m.041.07c-.072.001-.161.065-.16.143s.091.139.164.138s.333-.122.333-.145s-.264-.137-.337-.136m-1.051-.555c-.002.104-.096.23-.207.227s-.198-.133-.196-.236s.179-.476.212-.475c.034 0 .194.38.191.484m.1.06c-.09.051-.158.192-.103.289s.21.113.301.062s.335-.382.319-.411s-.427.009-.517.06m.187-.519c-.002.086-.079.191-.172.189s-.165-.11-.163-.197c.002-.086.149-.396.177-.395s.16.317.158.403m.082.05c-.075.042-.131.16-.086.241s.175.094.25.051c.075-.042.279-.318.265-.342c-.012-.025-.353.007-.429.05m.191-.499c-.002.08-.074.177-.159.175s-.153-.102-.151-.182s.138-.367.164-.367c.025.001.148.294.146.374m.077.046c-.07.039-.122.148-.079.223s.162.087.232.047s.259-.295.246-.317s-.33.008-.399.047m-.845-1.708c.041.096.007.249-.095.292s-.235-.039-.276-.135s-.033-.508-.002-.521c.031-.012.333.269.373.364m.115.014c-.061.084-.064.24.025.306c.09.066.238.016.299-.068s.148-.486.122-.506s-.384.184-.446.268m-.043-.55c.034.079.006.207-.079.243s-.196-.033-.229-.112s-.027-.422-.002-.433s.277.223.31.302m.096.011c-.051.07-.054.2.021.255s.198.013.249-.056c.051-.07.123-.405.101-.421s-.32.153-.371.222m-.031-.532c.031.074.006.192-.073.225s-.182-.03-.213-.104s-.025-.391-.001-.401c.023-.01.256.206.287.28m.089.01c-.047.065-.05.185.019.236s.184.012.231-.052c.047-.065.114-.375.094-.39s-.297.142-.344.206m-.033-.46c.028.067.005.173-.066.204c-.071.03-.164-.027-.193-.094s-.023-.354-.001-.363s.232.187.26.253m.081.01c-.043.058-.045.168.018.214s.166.011.209-.047s.104-.339.085-.353c-.019-.015-.269.127-.312.186m.881 1.521c-.025.101-.144.203-.251.176s-.165-.173-.139-.274s.279-.425.311-.417s.104.414.079.515m.084.08c-.099.03-.196.153-.164.26s.181.156.28.126s.411-.3.401-.331c-.008-.033-.417-.085-.517-.055m.297-.465c-.021.084-.119.169-.209.147s-.137-.144-.116-.228s.232-.354.259-.347s.086.344.066.428m.069.066c-.083.025-.163.127-.136.216s.15.13.233.105s.342-.249.334-.276c-.008-.026-.348-.069-.431-.045m.295-.444c-.019.078-.111.157-.194.136s-.127-.133-.108-.211s.215-.328.24-.322s.082.319.062.397m.065.062c-.077.023-.151.118-.126.2s.139.12.216.097s.317-.231.31-.256s-.323-.065-.4-.041m.251-.387c-.018.07-.1.142-.175.123s-.115-.121-.097-.191s.195-.297.217-.291c.022.005.072.289.055.359m.059.056c-.069.021-.137.107-.114.181c.022.074.126.109.195.088s.287-.209.28-.231s-.292-.059-.361-.038M25.8 16.98c.026.1-.028.247-.136.275s-.227-.073-.254-.173s.041-.507.073-.515s.291.312.317.413m.112.029c-.073.074-.098.228-.019.306s.233.05.306-.024s.217-.46.193-.483s-.407.128-.48.201m.037-.55c.022.084-.024.205-.113.229c-.089.023-.189-.06-.211-.144s.034-.422.061-.429c.026-.006.241.261.263.344m.093.025c-.061.062-.082.19-.016.255s.194.042.255-.02s.18-.383.161-.402s-.339.106-.4.167m.046-.531c.02.077-.022.191-.105.212c-.083.022-.175-.056-.196-.134c-.02-.077.032-.391.056-.398c.025-.006.224.242.245.32m.086.023c-.056.057-.076.176-.015.236s.18.039.236-.018s.167-.355.149-.373s-.314.098-.37.155m-1.336-1.141c.09.035.169.157.131.253s-.179.13-.268.095s-.357-.308-.345-.337c.011-.029.392-.046.482-.011m.084-.068c.015.095.117.199.219.182s.165-.147.15-.242s-.225-.414-.256-.409s-.129.374-.113.469m-.392-.328c.074.029.141.13.109.21s-.149.108-.223.079s-.297-.256-.287-.28c.009-.024.327-.039.401-.009m.07-.056c.013.079.097.165.182.151s.137-.122.125-.201s-.187-.344-.213-.34s-.107.311-.094.39m-.373-.326c.069.027.131.121.101.195s-.138.1-.207.073s-.275-.238-.266-.26s.303-.035.372-.008m.065-.052c.012.073.09.153.169.14s.127-.113.116-.187c-.012-.073-.174-.319-.197-.316c-.025.005-.1.29-.088.363m-.325-.277c.062.025.118.109.092.176s-.125.091-.187.066s-.249-.215-.241-.235s.273-.032.336-.007m.058-.047c.011.066.082.139.153.127s.115-.103.105-.169s-.157-.289-.178-.286c-.022.004-.09.262-.08.328m1.579.405c.05.082.041.227-.047.281s-.221-.004-.271-.086s-.1-.461-.073-.477s.34.2.391.282m.107-.003c-.045.085-.026.229.065.277s.22-.018.265-.103s.069-.466.042-.481s-.327.221-.372.307m-.115-.498c.042.068.034.189-.039.234s-.184-.003-.226-.071s-.083-.383-.061-.397s.284.165.326.234m.09-.003c-.037.071-.022.191.054.23s.183-.015.221-.086c.037-.071.057-.388.035-.4c-.023-.012-.273.185-.31.256m-.103-.484c.039.063.032.175-.036.217s-.171-.003-.209-.066c-.039-.063-.077-.355-.057-.368s.263.153.302.217m.083-.003c-.035.066-.02.177.05.214s.17-.014.205-.08s.053-.36.032-.371s-.252.171-.287.237m-.093-.417c.035.057.029.158-.033.196c-.061.038-.154-.002-.189-.06s-.07-.322-.051-.333c.018-.011.238.14.273.197m.075-.002c-.031.059-.018.16.046.193s.154-.013.185-.072s.048-.325.029-.335s-.228.154-.26.214m-.916.611c.084.048.145.179.094.269c-.051.089-.196.103-.279.055s-.309-.356-.293-.383c.014-.027.394.011.478.059m.092-.055c.002.096.087.213.19.212s.185-.122.183-.218s-.163-.442-.194-.442c-.03.001-.18.352-.179.448m-.34-.381c.069.04.121.149.078.224c-.042.074-.162.085-.232.045c-.069-.04-.257-.296-.244-.319c.013-.022.329.01.398.05m.077-.046c.001.08.072.178.158.176c.086-.001.154-.101.152-.181c-.001-.08-.136-.368-.161-.367c-.025 0-.15.292-.149.372m-.322-.375c.064.037.112.138.072.207s-.151.08-.215.043s-.238-.275-.226-.296s.305.009.369.046m.072-.043c.001.074.067.165.147.163c.08-.001.142-.094.141-.168s-.126-.341-.15-.341s-.139.272-.138.346"
          ></path>
          <path
            fill="#fff"
            d="M25.46 23.116s-.716-.008-1.328-.421s-1.865-1.173-2.868-.188c0 0 .7-.118 1.226.319c.526.438 1.341.951 2.027.894s.943-.604.943-.604"
          ></path>
          <path
            fill="#ff5b57"
            d="m13.013 12.188l-.884-.884c1.581-1.581 3.682-2.451 5.917-2.451s4.336.871 5.917 2.451l-.885.884c-1.344-1.344-3.131-2.085-5.032-2.085s-3.689.741-5.033 2.085"
          ></path>
          <path
            fill="#fff"
            d="m14.579 21.801l-.008-.632h6.789l.027.646z"
          ></path>
          <g fill="#fff">
            <path d="m21.387 15.549l-.57-.071v-1.335c0-.03-.01-.057-.017-.085h.027a.16.16 0 0 0 .159-.159a.16.16 0 0 0-.159-.159h-.707a.16.16 0 0 0-.159.159a.16.16 0 0 0 .159.159h.027c-.007.028-.017.055-.017.085v1.25l-.261-.032l-.518-.557a.93.93 0 0 0 .167-.515c0-.62-.641-1.122-1.433-1.122s-1.433.502-1.433 1.122c0 .185.063.358.164.512l-.521.561l-.262.032v-1.25c0-.03-.01-.057-.017-.085h.027a.16.16 0 0 0 .159-.159a.16.16 0 0 0-.159-.159h-.706a.16.16 0 0 0-.159.159a.16.16 0 0 0 .159.159h.027c-.007.028-.017.055-.017.085v1.335l-.569.07l.472.707h.074v.978h.731v-.978h4.053v.978h.731v-.978h.076z"></path>
            <path d="M20.473 13.624c.27 0 .488-.116.488-.259c0-.078-.069-.146-.173-.194l-.316-.453l-.315.453c-.104.047-.173.115-.173.194c.001.143.22.259.489.259m-2.447-.593c.28 0 .507-.14.507-.312c0-.092-.067-.172-.169-.229l-.338-.486l-.338.486c-.102.057-.169.138-.169.229c0 .172.227.312.507.312m-2.337.593c.27 0 .488-.116.488-.259c0-.078-.069-.146-.173-.194l-.315-.453l-.315.453c-.104.047-.173.115-.173.194c0 .143.218.259.488.259"></path>
          </g>
          <g fill="#fff">
            <path d="m21.32 20.864l-.481-.52v-.911h-.731v.874h-.294l-1.884-2.61l-1.438-.077l-.073 2.225l1.889.019l.888.443v.557z"></path>
            <path d="M16.054 19.433h-.73v.954l-.442.477h2.123v-.557h-.951zm-1.971-3.595l-.224.196s-.969.706-.647 1.388c-.18.251-.588.753-.275 1.263c.314.51.612.965.416 1.443c.588-.306.855-.871.674-1.506c-.151-.533.597-.941.844-1.06l.452.682v.628h.731v-1.078h-.633zm8.867 1.585c.322-.682-.647-1.388-.647-1.388l-.224-.196l-1.338 1.956h-.633v1.078h.731v-.628l.452-.682c.246.118.995.526.844 1.06c-.18.635.086 1.2.674 1.506c-.196-.478.102-.933.416-1.443c.313-.51-.095-1.012-.275-1.263"></path>
          </g>
          <path
            fill="#fff"
            d="M21.672 26.085a.35.35 0 0 1-.348.348c-.192 0-1.289-.156-1.289-.348s1.097-.348 1.289-.348c.193 0 .348.156.348.348"
          ></path>
          <path
            fill="#fff"
            d="M22.922 26.111c.98-.183 1.019-.713 1.019-.713s-.533.339-1.16.214s-1.193-.105-1.193-.105s.597.662.095.991c-.222.146-.837.084-1.105.025s-.845-.166-.971-.166a.348.348 0 0 0 0 .696c.128 0 .698-.106.995-.174s.505-.1.728-.146c.267-.055.824.016 1.522.071s1.208-.267 1.443-.549c-.495.157-1.146-.031-1.373-.144m4.706-7.901c.039-.095-.856.573-1.467.498s-1.785-.242-2.025.214c-.241.455-.456.927-.456.927s.407-.237.934-.24c.529-.003 1.64-.054 2.077-.2c.439-.147.781-.824.937-1.199m-.845-2.954c-.011-.199-.407-.115-.489-.28c-.081-.165.222-.516.054-.635c-.167-.119-1.019.644-1.493 1.155c-.474.512-.606 1.329-.453 1.57c.151.241.054.021.054.021s.3-.595.781-.838c.481-.242 1.546-.993 1.546-.993m-12.902 8.527c.032.08.141.151.227.117s.116-.161.084-.241s-.277-.319-.303-.309s-.04.353-.008.433m-.06.075c.085.014.179.104.164.196c-.015.091-.131.149-.217.135s-.372-.201-.368-.228s.336-.116.421-.103m-.352-.401c.03.074.131.14.21.109s.108-.149.078-.224s-.257-.296-.281-.287s-.037.328-.007.402m-.056.07c.079.013.166.097.152.182s-.122.138-.201.125s-.345-.186-.341-.212s.311-.107.39-.095m1.831.538c.019.102.13.212.24.192s.175-.162.157-.264c-.019-.102-.251-.442-.284-.436s-.132.406-.113.508m-.089.074c.097.036.186.166.147.27s-.19.144-.288.108s-.391-.325-.379-.357c.011-.031.423-.057.52-.021m-.266-.483c.015.085.108.176.199.16c.091-.017.146-.135.13-.22s-.209-.368-.236-.363s-.108.338-.093.423m-.074.062c.081.03.154.138.122.224s-.158.12-.239.09s-.325-.271-.315-.297c.009-.025.351-.047.432-.017m-.266-.462c.014.079.1.163.185.148s.135-.125.121-.204s-.194-.341-.219-.337s-.101.314-.087.393m-.068.057c.075.028.143.128.113.208s-.147.111-.222.083s-.301-.251-.293-.275c.01-.024.327-.044.402-.016m-.225-.402c.013.071.091.148.167.134s.122-.113.109-.184s-.175-.309-.198-.304c-.023.003-.091.283-.078.354m-.063.052c.068.025.13.115.102.188c-.027.073-.133.1-.201.075s-.273-.227-.265-.249c.01-.021.297-.039.364-.014m.098 1.755c.076.07.231.091.307.009s.043-.235-.033-.305s-.467-.202-.489-.178c-.024.025.138.404.215.474m-.027.113c.1-.029.248.021.279.127c.032.107-.066.229-.165.259c-.1.029-.508-.025-.517-.057s.304-.299.403-.329m-.502-.226c.063.059.192.076.255.008s.036-.195-.028-.254c-.063-.059-.388-.168-.407-.148s.116.335.18.394m-.022.094c.083-.025.206.017.232.106s-.054.191-.137.215c-.083.025-.422-.021-.43-.047c-.008-.027.252-.25.335-.274m-.491-.21c.059.054.178.07.237.007s.033-.181-.026-.235s-.36-.156-.377-.137s.107.31.166.365m-.02.087c.077-.023.191.016.216.098s-.051.177-.127.2s-.392-.019-.399-.044s.233-.231.31-.254m-.422-.186c.053.049.161.064.214.007s.03-.164-.023-.213s-.326-.141-.341-.124s.097.281.15.33m-.018.079c.069-.021.173.014.195.089c.022.074-.046.16-.115.181s-.354-.017-.361-.04c-.007-.022.211-.209.281-.23m-.343-2.771c-.013.103.061.241.172.254s.215-.103.228-.206s-.109-.497-.142-.501s-.246.35-.258.453m-.107.044c.082.063.128.213.06.301s-.224.081-.307.018s-.277-.427-.257-.453s.421.071.504.134m-.111-.54c-.01.086.051.2.143.212s.179-.085.19-.171c.01-.086-.091-.413-.118-.417c-.028-.003-.204.29-.215.376m-.089.037c.068.053.107.177.05.25s-.187.067-.255.015s-.23-.355-.213-.377c.017-.021.35.06.418.112m-.117-.52c-.01.079.047.186.133.196s.166-.079.176-.159c.01-.079-.084-.383-.109-.386s-.19.269-.2.349m-.082.034c.063.049.099.164.046.232c-.052.068-.173.063-.236.014s-.214-.329-.198-.349s.324.054.388.103m-.096-.45c-.009.072.043.168.12.178s.15-.072.159-.144s-.076-.347-.099-.349c-.023-.004-.171.243-.18.315m-.075.031c.057.044.089.149.042.21s-.157.057-.214.012c-.057-.044-.193-.298-.179-.316s.294.049.351.094m-.427 1.705c.052.09.194.156.29.1s.11-.212.059-.301s-.386-.332-.414-.315s.013.426.065.516m-.059.1c.104.001.231.093.229.204s-.131.2-.234.198c-.104-.001-.478-.174-.477-.208c0-.032.378-.195.482-.194m-.413-.365c.043.075.161.129.241.083s.092-.176.049-.251s-.321-.276-.345-.262s.012.355.055.43m-.049.083c.086.001.192.078.191.17s-.109.166-.195.165s-.397-.145-.397-.173s.315-.163.401-.162m-.406-.346c.04.069.15.12.224.077s.085-.163.045-.232s-.297-.256-.32-.243s.011.329.051.398m-.045.077c.08.001.178.072.177.158s-.101.154-.181.153s-.368-.135-.368-.16s.292-.152.372-.151m-.348-.302c.036.063.135.109.203.07c.067-.039.077-.148.041-.21s-.269-.231-.289-.22c-.021.011.009.297.045.36m-.041.07c.072.001.161.065.16.143s-.091.139-.164.138s-.333-.122-.333-.145c.001-.023.265-.137.337-.136m1.051-.555c.002.104.096.23.207.227s.198-.133.196-.236s-.179-.476-.212-.475c-.034 0-.193.38-.191.484m-.099.06c.09.051.158.192.103.289s-.21.113-.301.062c-.09-.051-.335-.382-.319-.411c.016-.03.426.009.517.06m-.187-.519c.002.086.079.191.172.189s.165-.11.163-.197c-.002-.086-.149-.396-.177-.395s-.16.317-.158.403m-.083.05c.075.042.131.16.086.241s-.175.094-.25.051s-.279-.318-.265-.342c.013-.025.354.007.429.05m-.19-.499c.002.08.074.177.159.175s.153-.102.151-.182s-.138-.367-.164-.367c-.025.001-.148.294-.146.374m-.077.046c.07.039.122.148.079.223s-.162.087-.232.047s-.259-.295-.246-.317s.329.008.399.047m.844-1.708c-.041.096-.007.249.095.292s.235-.039.276-.135s.033-.508.002-.521c-.031-.012-.332.269-.373.364m-.115.014c.061.084.064.24-.025.306c-.09.066-.238.016-.3-.068c-.061-.084-.148-.486-.122-.506s.386.184.447.268m.043-.55c-.034.079-.006.207.079.243s.196-.033.229-.112s.027-.422.002-.433s-.276.223-.31.302m-.096.011c.051.07.054.2-.021.255s-.198.013-.249-.056c-.051-.07-.123-.405-.101-.421c.022-.017.32.153.371.222m.032-.532c-.031.074-.006.192.073.225s.182-.03.213-.104s.025-.391.001-.401c-.023-.01-.256.206-.287.28m-.089.01c.047.065.05.185-.019.236s-.184.012-.231-.052c-.047-.065-.114-.375-.094-.39s.296.142.344.206m.032-.46c-.028.067-.005.173.066.204c.071.03.164-.027.193-.094s.023-.354.001-.363s-.232.187-.26.253m-.081.01c.043.058.045.168-.018.214s-.166.011-.209-.047s-.104-.339-.085-.353c.02-.015.27.127.312.186m-.881 1.521c.025.101.144.203.251.176s.165-.173.139-.274s-.279-.425-.311-.417s-.104.414-.079.515m-.084.08c.099.03.196.153.164.26s-.181.156-.28.126s-.411-.3-.401-.331c.009-.033.418-.085.517-.055m-.296-.465c.021.084.119.169.209.147s.137-.144.116-.228s-.232-.354-.259-.347s-.087.344-.066.428m-.07.066c.083.025.163.127.136.216s-.15.13-.233.105s-.342-.249-.334-.276c.008-.026.348-.069.431-.045m-.295-.444c.019.078.111.157.194.136s.127-.133.108-.211s-.215-.328-.24-.322s-.081.319-.062.397m-.065.062c.077.023.151.118.126.2s-.139.12-.216.097s-.317-.231-.31-.256s.323-.065.4-.041m-.25-.387c.018.07.1.142.175.123s.115-.121.097-.191s-.195-.297-.217-.291c-.023.005-.073.289-.055.359m-.059.056c.069.021.137.107.114.181c-.022.074-.126.109-.195.088s-.287-.209-.28-.231s.291-.059.361-.038m1.163-.243c-.026.1.028.247.136.275s.227-.073.254-.173s-.041-.507-.073-.515s-.29.312-.317.413m-.112.029c.073.074.098.228.019.306s-.233.05-.306-.024s-.217-.46-.193-.483s.407.128.48.201m-.036-.55c-.022.084.024.205.113.229c.089.023.189-.06.211-.144s-.034-.422-.061-.429s-.242.261-.263.344m-.094.025c.061.062.082.19.016.255s-.194.042-.255-.02s-.18-.383-.161-.402s.34.106.4.167m-.045-.531c-.02.077.022.191.105.212c.083.022.175-.056.196-.134c.02-.077-.032-.391-.056-.398c-.026-.006-.225.242-.245.32m-.087.023c.056.057.076.176.015.236s-.18.039-.236-.018s-.167-.355-.149-.373s.314.098.37.155m1.337-1.141c-.09.035-.169.157-.131.253s.179.13.268.095s.357-.308.345-.337c-.011-.029-.393-.046-.482-.011m-.084-.068c-.015.095-.117.199-.219.182s-.165-.147-.15-.242s.225-.414.256-.409c.03.005.128.374.113.469m.391-.328c-.074.029-.141.13-.109.21s.149.108.223.079s.297-.256.287-.28c-.009-.024-.326-.039-.401-.009m-.069-.056c-.013.079-.097.165-.182.151s-.137-.122-.125-.201s.187-.344.213-.34s.106.311.094.39m.372-.326c-.069.027-.131.121-.101.195s.138.1.207.073s.275-.238.266-.26c-.008-.022-.303-.035-.372-.008m-.064-.052c-.012.073-.09.153-.169.14s-.127-.113-.116-.187c.012-.073.174-.319.197-.316c.024.005.1.29.088.363m.325-.277c-.062.025-.118.109-.092.176s.125.091.187.066s.249-.215.241-.235s-.274-.032-.336-.007m-.059-.047c-.011.066-.082.139-.153.127s-.115-.103-.105-.169s.157-.289.178-.286c.023.004.091.262.08.328m-1.578.405c-.05.082-.041.227.047.281s.221-.004.271-.086s.1-.461.073-.477c-.026-.016-.341.2-.391.282m-.108-.003c.045.085.026.229-.065.277s-.22-.018-.265-.103s-.069-.466-.042-.481s.327.221.372.307m.115-.498c-.042.068-.034.189.039.234s.184-.003.226-.071s.083-.383.061-.397s-.284.165-.326.234m-.089-.003c.037.071.022.191-.054.23s-.183-.015-.221-.086c-.037-.071-.057-.388-.035-.4c.023-.012.273.185.31.256m.102-.484c-.039.063-.032.175.036.217s.171-.003.209-.066c.039-.063.077-.355.057-.368s-.263.153-.302.217m-.083-.003c.035.066.02.177-.05.214s-.17-.014-.205-.08s-.053-.36-.032-.371s.253.171.287.237m.093-.417c-.035.057-.029.158.033.196s.154-.002.189-.06s.07-.322.051-.333c-.018-.011-.238.14-.273.197m-.075-.002c.031.059.018.16-.046.193s-.154-.013-.185-.072s-.048-.325-.029-.335s.229.154.26.214m.917.611c-.084.048-.145.179-.094.269c.051.089.196.103.279.055s.309-.356.293-.383c-.015-.027-.395.011-.478.059m-.093-.055c-.002.096-.087.213-.19.212s-.185-.122-.183-.218s.163-.442.194-.442c.031.001.181.352.179.448m.34-.381c-.069.04-.121.149-.078.224c.043.074.163.086.232.046s.257-.296.244-.319c-.012-.023-.329.009-.398.049m-.077-.046c-.001.08-.072.178-.158.176c-.086-.001-.154-.101-.152-.181c.001-.08.136-.368.161-.367c.025 0 .15.292.149.372m.322-.375c-.064.037-.112.138-.072.207s.151.08.215.043s.238-.275.226-.296s-.305.009-.369.046m-.071-.043c-.001.074-.067.165-.147.163c-.08-.001-.142-.094-.141-.168s.126-.341.15-.341s.139.272.138.346"
          ></path>
          <path
            fill="#fff"
            d="M10.469 23.116s.716-.008 1.328-.421s1.865-1.173 2.868-.188c0 0-.7-.118-1.226.319c-.526.438-1.341.951-2.027.894c-.685-.056-.943-.604-.943-.604m9.849 1.449s-1.2.353-2.353.329c-1.153.024-2.353-.329-2.353-.329l-1.106 1.059s.424-.129 1.129.188c.66.297 1.424.608 2.329.608s1.67-.311 2.329-.608c.706-.318 1.129-.188 1.129-.188z"
          ></path>
          <path
            fill="#fff"
            d="M14.257 26.085c0 .192.156.348.348.348s1.289-.156 1.289-.348s-1.097-.348-1.289-.348s-.348.156-.348.348"
          ></path>
          <path
            fill="#fff"
            d="M13.008 26.111c-.98-.183-1.019-.713-1.019-.713s.533.339 1.16.214s1.193-.105 1.193-.105s-.597.662-.095.991c.222.146.837.084 1.105.025s.845-.166.971-.166a.348.348 0 0 1 0 .696c-.128 0-.698-.106-.995-.174s-.505-.1-.728-.146c-.267-.055-.824.016-1.522.071s-1.208-.267-1.443-.549c.494.157 1.145-.031 1.373-.144M8.301 18.21c-.039-.095.856.573 1.467.498s1.785-.242 2.025.214c.241.455.456.927.456.927s-.407-.237-.934-.24c-.529-.003-1.64-.054-2.077-.2s-.781-.824-.937-1.199m.845-2.954c.011-.199.407-.115.489-.28s-.222-.516-.054-.635c.167-.119 1.019.644 1.493 1.155c.474.512.606 1.329.453 1.57c-.151.241-.054.021-.054.021s-.3-.595-.781-.838c-.481-.242-1.546-.993-1.546-.993m11.054 7.82c-.196.048-.44.292-.669.633a.635.635 0 0 0-.631-.595a.7.7 0 0 0-.229.046a.45.45 0 0 0-.371-.199a.46.46 0 0 0-.312.125a.46.46 0 0 0-.312-.125a.46.46 0 0 0-.371.199a.6.6 0 0 0-.229-.046a.64.64 0 0 0-.638.631c-.236-.359-.488-.619-.691-.668c-.335-.082-.594-.435-.818-.594c0 0 .021.607.624 1.041c.4.288.294.953.294.953s.729.182 1.059.218c-.05-.147-.115-.281-.177-.416a.6.6 0 0 0 .19.085l.186.347s.428.039.881.039s.884-.039.884-.039l.186-.347a.7.7 0 0 0 .15-.057c-.058.127-.118.252-.165.389c.329-.035 1.059-.218 1.059-.218s-.106-.665.294-.953c.602-.434.624-1.041.624-1.041c-.224.157-.483.51-.818.592"
          ></path>
        </svg>
      ),
    },
    {
      id: 4,
      name: "۹۶۴+",
      code: "+964",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 36 36"
        >
          <path
            fill="#141414"
            d="M0 27a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-4H0z"
          ></path>
          <path fill="#eee" d="M0 13h36v10H0z"></path>
          <path
            fill="#dd2e44"
            d="M32 5H4a4 4 0 0 0-4 4v4h36V9a4 4 0 0 0-4-4"
          ></path>
          <g fill="#007a3c">
            <path d="M11.227 18.06v1.229h5.651v-.737c0-.328-.369-.308-.369-.062v.552h-4.423v-.86l3.102-3.102l.471.501l-2.815 2.846h2.928s.133-.86.931-.86l.912.635v2.314h-8.23s-.205 1.085-1.454.941c0 0 .86-.573.86-1.249c0-.675-.552-1.208-.552-1.208l.778-.491s.082.42.164.542c.083.122.389.235.389.235h1.044l-.014-.546l-.151-.065zm8.302 1.002l-.166.227h-.487c.002-1.151.006-3.418-.001-3.441c-.01-.031.215-.194.215-.194l-.982-.542v5.406h1.843zm5.458-3.09v3.317h-.491V16.34l-.615.615v2.335h-.491v-1.966l-.613.615v.006l-.134.127l.134.052v.457c-.586-.301-1.229.155-1.229.71v1.228h4.053V15.36zm-2.564 3.317h-.036c-.246 0-.215-.328.123-.328c.188 0 .248.101.267.191v.137zm1.315-4.208c0 .152-.051.277-.113.277s-.112-.124-.112-.277s.051-.276.112-.276c.063 0 .113.123.113.276m-1.034.747s.184.175.523.123c.338-.051.45-.358.45-.358s.194.317.409.266c.216-.051.41-.389.41-.389s.01.542-.308.593c-.317.051-.45-.174-.45-.174s-.164.246-.471.266c-.307.022-.563-.327-.563-.327m4.944 3.205l-.265.256h-.43v-3.491l.255-.113l-.992-.573v5.406h1.852z"></path>
            <path d="M10.716 21.132a.267.267 0 1 1-.533-.001a.267.267 0 0 1 .533.001"></path>
          </g>
        </svg>
      ),
    },
  ];

  const [selectedCode, setSelectedCode] = useState(code[0]);

  const loc = useLocation();

  const params = useParams();

  const username = params.username;

  useEffect(() => {
    setIsRegistered(null);
    setResetPassword(false);
    setChangePassword(false);
    setValidate(false);
    setLoading(false);
    setStepper(1);
    setIsComplite(false);

    if (params.ref) {
      setItemStorage("ref", params.ref);
    }

    // get company panel info
    if (loc.pathname.includes("/panel")) {
      postData("/company-info", { username })
        .then((res) => {
          setCompanyInfo(res.data);
          setCompanyLoading(false);
        })
        .catch((err) => {});
    } else {
      setCompanyLoading(false);
    }
  }, [loc]);
  // prevent to type letters
  const onChangeHandler = (e) => {
    const onlyNum = /^[0-9\b]+$/;

    if (e.target.value === "" || onlyNum.test(e.target.value)) {
      setPhoneNumber(getValues("phone_number"));
    }
  };

  const submitHandler = (e, url, resetPass) => {
    e.preventDefault();
    // phone number lentgh limit

    // post data to api
    setErr(false);
    setLoading(true);

    postData(url, { ...getValues(), code: selectedCode?.code }, false)
      .then((res) => {
        if (res.data.status === "success") {
          setServerRes(res);
          authContext.userPhoneNumber(res.data, phoneNumber);
          !resetPass &&
            (res.data.description === "code"
              ? setIsRegistered(false)
              : setIsRegistered(true));
          if (resetPass) {
            setChangePassword(true);
            setIsRegistered(false);
            setResetPassword(false);
          }

          setStepper(2);
        }

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setErr(true);
        setErrMsg(err.response?.data.phone_number);
      });
  };

  const backBtnHandler = () => {
    setIsRegistered(null);
    setChangePassword(false);
    setResetPassword(false);
    setStepper(1);
    setErr(false);
  };

  const passwordRecoveryHandler = () => {
    setResetPassword(true);
    setErr(false);
    setErrMsg("");
    // setPhoneNumber("");
  };

  return (
    <div className="min-h-screen h-fit overflow-y-auto py-6 w-full flex flex-col gap-5 justify-center items-center pb-28 lg:pb-6 px-4">
      {companyLoading ? (
        <Loading />
      ) : (
        <>
          <Link
            to={"/"}
            style={companyInfo.name && { color: `#${companyInfo.color}` }}
            className="text-yellow-700 text-sm absolute top-5 left-5"
          >
            بازگشت به سایت
          </Link>

          <MobileNavbar />

          <Stepper stepNum={stepper} registered={isRegistered} />
          {/* {companyInfo.name && (
            <div className="w-full lg:w-[400px] px-4 flex justify-between items-center">
              <img
                src={`https://api.myunibest.com/${companyInfo.logo}`}
                className="w-20 rounded-full"
                alt=""
              />
              <h1 className="text-center text-2xl font-extrabold text-gray-200">
                {companyInfo.name}
              </h1>
            </div>
          )} */}

          <div className="lg:w-[400px] relative w-full h-auto rounded-xl p-4 bg-[#222] shadow-lg ">
            {/* bg-gradient-to-b from-yellow-700 to-[#222] */}
            {companyInfo.name && (
              <div
                style={{
                  background: `linear-gradient(0deg, #222 5%, #${companyInfo.color} 115%)`,
                }}
                className="absolute w-full h-28 right-0 top-0"
              >
                <div className="relative w-full h-full"></div>
              </div>
            )}
            <div className="relative flex flex-col items-center gap-3 py-2 mb-3">
              {companyInfo.name ? (
                <>
                  <div className="w-20 h-20 flex justify-center items-center rounded-full bg-gray-800">
                    {!imageLoaded && <CircleLoading />}

                    <img
                      src={`https://api.myunibest.com/${companyInfo.logo}`}
                      className={`w-20 rounded-full ${
                        !imageLoaded && "hidden"
                      }`}
                      alt=""
                      onLoad={() => setImageLoaded(true)}
                    />
                  </div>

                  <h1 className="text-center text-2xl font-extrabold text-gray-200">
                    {companyInfo.name}
                  </h1>
                  {resetPassword || changePassword ? (
                    <span className="text-gray-400 text-sm">
                      بازیابی رمز عبور
                    </span>
                  ) : authContext.userInfo.completeProfile && isComplite ? (
                    <span className="text-gray-400 text-sm">
                      تکمیل اطلاعات کاربری
                    </span>
                  ) : (
                    <span className="text-gray-400 text-sm">
                      ورود یا ثبت نام
                    </span>
                  )}
                </>
              ) : (
                <h1 className="text-center text-2xl font-extrabold text-gray-200">
                  {resetPassword || changePassword ? (
                    <span>بازیابی رمز عبور</span>
                  ) : authContext.userInfo.completeProfile && isComplite ? (
                    <span>تکمیل اطلاعات کاربری</span>
                  ) : (
                    <span>ورود یا ثبت نام</span>
                  )}
                </h1>
              )}
              <button
                onClick={backBtnHandler}
                className={`absolute ${
                  (isRegistered !== null && !isComplite) || resetPassword
                    ? "block"
                    : "hidden"
                } border border-gray-800 rounded-lg right-0 top-2/4 -translate-y-2/4 p-1 hover:bg-slate-100 transition-all duration-300`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-[18px] h-[18px] stroke-gray-200"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                  />
                </svg>
              </button>
            </div>

            {err && (
              <NoticeMsg
                msg={
                  errMsg
                    ? errMsg
                    : validate
                    ? "فیلد شماره موبایل الزامی میباشد."
                    : "لطفا دوباره تلاش کنید."
                }
                notice={"error"}
              />
            )}

            {/* auth enter phone number */}
            {isRegistered === null && !isComplite && !resetPassword && (
              <form
                onSubmit={(e) =>
                  submitHandler(e, p_get_login_sms_code.url, false)
                }
                onChange={onChangeHandler}
                className={`login-form flex flex-col gap-4 mt-6 transition-all duration-300`}
              >
                <div className="w-full relative">
                  {/* open code dropwdown */}
                  <div
                    onClick={() => setCodeOpen(!codeOpen)}
                    className="w-[90px] cursor-pointer h-8 absolute top-10 flex items-center justify-between p-1.5 bg-gray-800 rounded-lg left-2 z-10"
                  >
                    <div className="flex items-center gap-1">
                      {selectedCode?.icon}

                      <span className="text-sm text-gray-200">
                        {selectedCode?.name}
                      </span>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-4 text-gray-200"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m19.5 8.25-7.5 7.5-7.5-7.5"
                      />
                    </svg>
                  </div>

                  {/* dropdown */}
                  <div
                    className={`w-[90px] ${
                      codeOpen
                        ? "opacity-100 visible translate-y-0"
                        : "opacity-0 invisible translate-y-5"
                    } h-auto rounded-lg bg-gray-800 absolute top-[78px] left-2 z-10 flex flex-col gap-0.5 overflow-hidden transition-all duration-300`}
                  >
                    {code.map((item) => (
                      <div
                        onClick={() => {
                          setSelectedCode(item);
                          setCodeOpen(false);
                        }}
                        className={`flex items-center cursor-pointer gap-1 p-1.5 ${
                          item.id === selectedCode?.id
                            ? "bg-gray-700"
                            : "bg-gray-800"
                        } hover:bg-gray-700 transition-all duration-300`}
                      >
                        {item?.icon}

                        <span className="text-sm text-gray-200">
                          {item?.name}
                        </span>
                      </div>
                    ))}
                  </div>

                  <Input
                    element={"input"}
                    type={p_get_login_sms_code.input.phone_number.type}
                    label={p_get_login_sms_code.input.phone_number.label}
                    placeHolder={`${p_get_login_sms_code.input.phone_number.label} خود را وارد کنید`}
                    register={{ ...register("phone_number") }}
                    value={phoneNumber}
                    className={`text-lg placeholder:text-sm !pl-[105px]`}
                    aos={"slide-up"}
                    labelClass={"!text-gray-200"}
                  />
                </div>
                {/* submit button */}
                <button
                  disabled={loading}
                  style={
                    companyInfo.name && {
                      background: `linear-gradient(to top left, #${companyInfo.color}, #${companyInfo.color}80)`,
                    }
                  }
                  className="bg-gradient-to-tl from-yellow-900 to-yellow-500 hover:bg-opacity-80 animate-delay-2 text-white w-full h-11 rounded-xl shadow-lg transition-all duration-300"
                  type="submit"
                >
                  {loading ? (
                    <Loading color={"before:!bg-white"} />
                  ) : (
                    "ورود یا ثبت نام"
                  )}
                </button>
              </form>
            )}

            {/* reset password enter phone number */}
            {resetPassword && (
              <form
                onSubmit={(e) => submitHandler(e, p_change_pass_code.url, true)}
                onChange={onChangeHandler}
                className={`reset-pass flex flex-col gap-4 mt-6 transition-all duration-300`}
              >
                <Input
                  element={"input"}
                  className="text-lg placeholder:text-sm"
                  type={p_get_login_sms_code.input.phone_number.type}
                  label={p_get_login_sms_code.input.phone_number.label}
                  placeHolder={`${p_get_login_sms_code.input.phone_number.label} خود را وارد کنید`}
                  register={{ ...register("phone_number") }}
                  value={phoneNumber}
                  labelClass={"!text-gray-200"}
                />

                {!loading ? (
                  // submit button
                  <button
                    style={
                      companyInfo.name && {
                        background: `linear-gradient(to top left, #${companyInfo.color}, #${companyInfo.color}80)`,
                      }
                    }
                    className="bg-gradient-to-tl from-yellow-900 to-yellow-500 hover:opacity-80 animate-delay-2 text-white w-full h-11 rounded-xl shadow-lg transition-all duration-300"
                    type="submit"
                  >
                    <span> بازیابی رمز عبور </span>
                  </button>
                ) : (
                  <Loading />
                )}
              </form>
            )}

            {/* forget password */}
            {isRegistered === null && !resetPassword && (
              <button
                style={companyInfo.name && { color: `#${companyInfo.color}` }}
                onClick={passwordRecoveryHandler}
                className="text-yellow-700 mt-4 animate-delay-4"
              >
                رمز عبور خود را فراموش کرده اید؟
              </button>
            )}

            {/* verification */}
            {isRegistered === false && !isComplite && (
              <Verification
                data={serverRes}
                registered={isRegistered}
                resetPassword={changePassword}
                setStepNum={setStepper}
                phoneNumber={getValues("phone_number")}
                setIsComplite={setIsComplite}
                companyInfo={companyInfo}
              />
            )}

            {/* login enter password */}
            {isRegistered && (
              <Password setStepNum={setStepper} companyInfo={companyInfo} />
            )}

            {/* complete register  */}
            {authContext.userInfo.completeProfile && isComplite && (
              <ProfileInfo setStepNum={setStepper} companyInfo={companyInfo} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Auth;
